import type { Writable } from 'svelte/store';

export interface I18n {
    t: (key: string, vars?: Record<string, any>) => string;
    locale?: string;
}

export type I18nStore = Writable<I18n>;

// Helper function to get typed i18n context
export const getTypedI18n = (context: any): I18nStore => {
    return context as I18nStore;
}; 